import { BrowserRouter as Router, Routes, Route, Navigate  } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext"; 
import ThemeToggle from "./components/ThemeToggle/ThemeToggle.jsx";      

import Home from './pages/home/index.tsx';
import NotFound from "./pages/NotFound/NotFound.tsx";




function App() {
  return (
    <ThemeProvider>
      <Router>
        <div style={{ padding: "1rem", position: "fixed", top: 0, right: 0, zIndex: 999 }}>
          <ThemeToggle />
        </div>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />

          <Route path="/servicio" element={<Navigate to="/#servicios" replace />} />
          <Route path="/proyecto" element={<Navigate to="/#proyectos" replace />} />
          

          <Route path="*" element={<NotFound />} /> 
        
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
